import { MenuLayoutEnum, MenuTemplateEnum } from '../../__generated__/graphql'
import { StoreCreatePubMenu } from '../pages/pub-menu/create/StoreCreatePubMenu'

export const resizeMenuTitleByLength = (
  textLength: number,
  store: StoreCreatePubMenu
) => {
  const Peroni1CharsPerLine = 16

  const pageSingleCategoriesFormat =
    store.settings.template.body.categories.single.heading.A4

  const pageDoubleCategoriesFormat =
    store.settings.template.body.categories.double.heading.A4

  const storeBaseFontSize = store.settings.getStyleForSelectedLayout(
    pageSingleCategoriesFormat || pageDoubleCategoriesFormat
  )?.fontSize as number

  if (store.settings.template.name === MenuTemplateEnum.Peroni1) {
    let baseFontSize = storeBaseFontSize ?? 53

    if (textLength > Peroni1CharsPerLine) {
      baseFontSize = baseFontSize - 29
    }

    return baseFontSize
  }

  return storeBaseFontSize
}

export const resizeHeadingHeightByLength = (
  textLength: number,
  store: StoreCreatePubMenu,
  heightValue: unknown
) => {
  const pilsnerUrquellCharsPerLine = 35

  if (
    textLength > pilsnerUrquellCharsPerLine &&
    store.settings.template.name === MenuTemplateEnum.PilsnerUrquell
  ) {
    if (typeof heightValue === 'string') {
      return `${heightValue + 20}px`
    }
    if (typeof heightValue === 'number') {
      return heightValue + 20
    }
  }

  return heightValue
}

export const resizeCoverPageTitleByLength = (
  textLength: number,
  store: StoreCreatePubMenu
) => {
  const firstMiddleCharsPerLineValue = 9
  const secondMiddleCharsPerLineValue = 4

  const templateName = store.settings.template.name
  let baseFontSize =
    (store.settings.getStyleForSelectedLayout(
      store.settings.template.cover?.title
    )?.fontSize as number) ?? 72

  switch (templateName) {
    case MenuTemplateEnum.Peroni1:
    case MenuTemplateEnum.Ursus:
      if (textLength > firstMiddleCharsPerLineValue) {
        baseFontSize -= 29 // output will be about ~43px
      }
      break

    case MenuTemplateEnum.Raffo1:
    case MenuTemplateEnum.Raffo2:
      if (textLength > firstMiddleCharsPerLineValue * 1.15) {
        baseFontSize *= 0.6
      }
      break

    case MenuTemplateEnum.Radegast:
    case MenuTemplateEnum.Gambrinus:
      if (textLength > secondMiddleCharsPerLineValue * 1.5) {
        baseFontSize *= 0.42 // output will be about ~75px
      }
      if (textLength > secondMiddleCharsPerLineValue * 3.5) {
        baseFontSize *= 0.7 // output will be about ~85px
      }
      break

    default:
      if (textLength > secondMiddleCharsPerLineValue * 1.75) {
        baseFontSize *= 0.7 // output will be about ~78px
      }
      if (textLength > secondMiddleCharsPerLineValue * 3) {
        baseFontSize *= 0.6 // output will be about ~46px
      }
  }

  return baseFontSize
}

export const resizeRestaurantNameByLength = (store: StoreCreatePubMenu) => {
  const subTitleA4FontSize = store.settings.template.cover?.subTitle.A4.fontSize
  const subTitleA5FontSize = store.settings.template.cover?.subTitle.A5.fontSize

  if (store.settings.template.name === MenuTemplateEnum.Raffo1) {
    return resizeCoverPageTitleByLength(
      store.settings.settingsForm.restaurantName.$?.length,
      store
    )
  }
  if (store.settings.templatesForm.layout.value === MenuLayoutEnum.A5) {
    return subTitleA5FontSize
  }
  return subTitleA4FontSize
}
